var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"},on:{"click":function($event){return _vm.$emit('onRefresh')}}},[_c('p',{attrs:{"id":"link"}},[_vm._v("New stories available! Refresh your feed")])])}
var staticRenderFns = []

export { render, staticRenderFns }